import { NgModule } from '@angular/core';
import { AuthStoreService } from './auth-store.service';
import { AzureModule } from '../../azure/azure.module';

@NgModule({
  imports: [AzureModule],
  providers: [AuthStoreService],
  exports: [],
})
export class AuthStoreModule {}
